import { Outlet, useNavigate } from "react-router-dom";
import { useSchool } from "@/context/SchoolContext";
import { Button } from "@/components/ui/button";

export default function RequireAdmin() {
  const { isAdmin, loading } = useSchool();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="h-[50vh] flex items-center justify-center">
        <div className="w-7 h-7 rounded-full border-[2.5px] border-border border-t-primary animate-spin" />
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
        <div className="max-w-sm w-full border border-border bg-card rounded-2xl px-8 py-10">
          <h1 className="text-xl font-semibold text-foreground mb-2">
            Admin access required
          </h1>
          <p className="text-sm text-muted-foreground mb-6 leading-relaxed">
            You don&apos;t have admin access to this school. If you believe this is an
            error, please contact your school admin.
          </p>
          <Button onClick={() => navigate("/schools")} className="w-full">
            Go to School
          </Button>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
